<template>
  <div>
    <br />
    <gmap-map :center="center" :zoom="12" style="width: 100%; height: 400px">
      <gmap-marker
        :position="locpoint.position"
        :draggable="true"
        @dragend="getMarkerloction($event)"
        @click="center = locpoint.position"
      ></gmap-marker>
    </gmap-map>
  </div>
</template>

<script>
export default {
  name: "LocationMap",
  props: {
    lat: {
      type: String,
    },
    lng: {
      type: String,
    },
  },
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 13.0827, lng: 80.2707 },
      markers: [],
      locpoint: {
        position: { lat: 13.0827, lng: 80.2707 },
      },
      places: [],
      currentPlace: null,
    };
  },

  mounted() {
    this.$root.$on("openCustomerMap", (item) => {
      this.center = item;
      this.locpoint.position = this.center;
      this.locpoint.title = "new marker";
    });
    this.geolocate();
    this.$root.$on("officeLocationMarkerSetting", (value) => {
      this.locpoint.position.lat = value.lat;
      this.locpoint.position.lng = value.lng;
    });
  },

  methods: {
    // receives a place object via the autocomplete component
    setPlace(place) {
      this.currentPlace = place;
    },
    emitLocation(data) {
      let self = this;
      self.$emit("on-loactionselect", data);
    },
    getMarkerloction(e) {
      let postion = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      this.locpoint.position = postion;
      this.center = postion;
      this.emitLocation(postion);
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.currentPlace = null;
      }
    },
    geolocate: function () {
      // navigator.geolocation.getCurrentPosition(position => {
      //   let temposition = { lat: 20.266666, lng: 55.316666 };
      //   // if(this.lat && this.lng) {
      //   //   temposition = {
      //   //     lat: this.lat,
      //   //     lng: this.lng
      //   //   }
      //   // }
      //   this.center = temposition;
      //   this.locpoint.position = this.center;
      //   this.markers.push({ position: this.center });
      //   this.emitLocation(temposition);
      // });
    },
    getcurrent() {
      navigator.geolocation.getCurrentPosition((position) => {});
    },
  },
  created: function () {
    // this.getcurrent();

    navigator.geolocation.getCurrentPosition(function (position) {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });
  },
};
</script>
